import { useEffect } from 'react';
// tslint:disable-next-line:import-blacklist
import { useHistory, useLocation } from 'react-router-dom';
import { useConfig } from '../../../../context';
import { mapRoutePath } from '../lib/mapRoutePath';
export const AlternativeRoutingRedirector = () => {
    var _a;
    const enabled = (_a = useConfig().global.alternativeRouting) !== null && _a !== void 0 ? _a : false;
    const history = useHistory();
    const location = useLocation();
    useEffect(() => {
        if (!enabled) {
            return;
        }
        const alt = mapRoutePath(location.pathname, true);
        if (alt !== location.pathname) {
            history.replace(Object.assign(Object.assign({}, location), { pathname: alt }));
        }
    }, [enabled, location.pathname]);
    return null;
};
